// TODO: Remove from `core-js@4`
require('../modules/esnext.promise.all-settled');
